import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[has-portfolio-type]' })
export class HasPortfolioTypeDirective implements OnChanges {
	@Input() public data;
	@Input('has-portfolio-type') public hasPortfolioType: Set<string>;

	constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (this.hasPortfolioType) {
			if (changes.data.currentValue.success) {
				const actualPortfolioTypes = new Set([]);

				changes.data.currentValue.portfolioData.forEach(portfolio => {
					if (portfolio.field['portfolioType']) {
						actualPortfolioTypes.add(portfolio.field['portfolioType'].rawValue);
					}
				});

				// actualPortfolioTypes has to be a superset of expectedPortfolioType to get a match
				let match: boolean = true;

				this.hasPortfolioType.forEach(expectedPortfolioType => {
					if (!actualPortfolioTypes.has(expectedPortfolioType)) {
						match = false;
					}
				});

				this.viewContainer.clear();
				if (match) {
					this.viewContainer.createEmbeddedView(this.templateRef);
				}
			}
		} else {
			this.viewContainer.clear();
			this.viewContainer.createEmbeddedView(this.templateRef);
		}
	}
}
